__turbopack_context__.v({
  "component": "style-module-scss-module__DypiXG__component",
  "exp-theme": "style-module-scss-module__DypiXG__exp-theme",
});
